import { useHead } from '#imports'

export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.env.VITE_APP_NODE_ENV !== 'production') return
  const gTagId = import.meta.env.VITE_APP_GTAG_ID

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.dataLayer = window.dataLayer || []
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  function gtag(){
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line prefer-rest-params
    dataLayer.push(arguments)
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  gtag('js', new Date())
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  gtag('config', 'G-C0CFCH3Z18')

  useHead({
    script: [
      {
        src: `https://www.googletagmanager.com/gtag/js?id=${gTagId}`,
        async: true,
      },
    ],
  })
})